module.exports = "<div id=item-map style=width:100%;height:300px> </div>";